import apiClient from './client'
import type { DashboardOverview, ErrorTrendResponse, RecentAlert, IncidentSummary } from '../types'

export interface RecentAlertsResponse {
  alerts: RecentAlert[]
}

export interface ActiveIncidentsResponse {
  incidents: IncidentSummary[]
  total: number
}

export const dashboardApi = {
  getOverview: async (): Promise<DashboardOverview> => {
    const response = await apiClient.get<DashboardOverview>('/dashboard')
    return response.data
  },

  getErrorsTrend: async (days = 7): Promise<ErrorTrendResponse> => {
    const response = await apiClient.get<ErrorTrendResponse>('/dashboard/errors-trend', {
      params: { days },
    })
    return response.data
  },

  getRecentAlerts: async (limit = 10): Promise<RecentAlertsResponse> => {
    const response = await apiClient.get<RecentAlertsResponse>('/dashboard/recent-alerts', {
      params: { limit },
    })
    return response.data
  },

  getActiveIncidents: async (): Promise<ActiveIncidentsResponse> => {
    const response = await apiClient.get<ActiveIncidentsResponse>('/dashboard/active-incidents')
    return response.data
  },
}

export type { DashboardOverview, ErrorTrendResponse, RecentAlert, IncidentSummary }
